<template>
  <div>
    <div class="flex flex-col justify-center">
      <p class="headerstyle">เพิ่มประเภทหลักสูตร</p>
      <div class="fromstyle">
        <form @submit.prevent="checkForm">
          <div id="fadeIn" v-if="errors.length">
            <b>กรุณากรอกข้อมูลให้ถูกต้อง :</b>
            <ul>
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </div>
          <vs-input
            class="w-full"
            id="curriculum"
            placeholder="ชื่อประเภทหลักสูตร"
            type="text"
            v-model="curriculum"
            name="curriculum"
            required
          />

          <select
            class="my-5 custom-select"
            v-model="usertype"
            id="usertype"
            name="usertype"
            required
          >
            <option :value="null" disabled selected>หลักสูตร</option>
            <option>หลักสูตรหลัก</option>
            <option>หลักสูตรเฉพาะกลุ่ม</option>
          </select>

          <div id="fadeIn" v-if="usertype == 'หลักสูตรเฉพาะกลุ่ม'">
            <label id="header">ประเภทของผู้เรียนที่สามารถเข้าเรียนได้</label>

            <multiselect
              class="cus-select"
              v-model="value"
              :options="options"
              placeholder="ประเภทผู้เรียน"
              label="name"
              track-by="name"
              :allow-empty="false"
            >
            </multiselect>
          </div>
          <vs-row vs-w="12">
            <vs-col vs-w="12" class="flex justify-center">
              <button type="submit" value="Submit" class="share-btn">
                เพิ่มแบบหลักสูตร
              </button>
            </vs-col>
          </vs-row>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../../util/backend";
import Multiselect from "vue-multiselect";
import baseUrl from "../../../util/baseUrl";

export default {
  methods: {
    async checkForm(e) {
      this.errors = [];

      if (!this.curriculum) {
        this.errors.push("กรุณากรอกชื่อประเภทคอร์สเรียน");
      }
      if (!this.usertype) {
        this.errors.push("กรุณาเลือกประเภทหลักสูตร");
      }
      if (this.usertype == "หลักสูตรเฉพาะกลุ่ม" && !this.value) {
        this.errors.push("กรุณาเลือกประเภทของผู้เรียนที่สามารถเข้าเรียนได้");
      }
      if (this.errors.length > 0) {
        for (const err of this.errors) {
          this.$vs.notify({
            title: "Error message",
            text: err,
            color: "danger",
            icon: "error",
            position: "top-right"
          });
        }
        return;
      }

      if (this.curriculum && this.usertype) {
        this.$vs.loading();
        if (this.usertype == "หลักสูตรหลัก") {
          this.value = { code: 1 };
        }
        let config = {
          method: "post",
          url: `${baseUrl.baseurl()}/createCategory_curriculum`,
          data: {
            title: this.curriculum.trimLeft(),
            type: this.usertype,
            organization_id: this.value ? this.value.code : 1
          }
        };
        await axios
          .api(config)
          .then(res => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "การสร้างประเภทคอร์สเรียน",
              text: "สำเร็จ",
              color: "success",
              icon: "check_box",
              position: "top-right"
            });
            this.$router.push({ path: "/curriculumType" });
          })
          .catch(err => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error message",
              text: `${
                err.response.data.error ? err.response.data.error : err
              }`,
              color: "danger",
              icon: "error",
              position: "top-right"
            });
          });
      }
    }
  },

  async mounted() {
    await this.$store.dispatch("general/get_organization_choice");
  },
  data() {
    return {
      curriculum: null,
      usertype: null,
      errors: [],
      value: null
    };
  },
  computed: {
    ...mapGetters({
      options: "general/choice"
    })
  },

  components: {
    Multiselect
  }
};
</script>

<style lang="scss" scoped>
.fromstyle {
  padding: 0;
}

.share-btn {
  background-color: #0430ad;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;

  &:hover {
    transition-delay: 100ms;
    background-color: #072c49;
  }
  &:active {
    background-color: #072c49;
  }
}

.headerstyle {
  color: #1a3683;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  text-align: center;
}
</style>

<style lang="scss">
.cus-select {
  font-size: 0.9rem !important;
  margin-bottom: 2rem !important;
}

// .cus-select .multiselect__tags {
//   font-size: .9rem !important;
//   border: 2px solid #0430AD;
// }
</style>
